import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("general");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    requirements: "",
    terms: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", formData);
    // TODO: Add form submission logic here
  };

  const basicFaqs = [
    {
      question: "What is GeeQR?",
      answer:
        "GeeQR are QR based simple digital solution by GeeCom India for less tech-savvy users. GeeQRs are grassroots-first, QR-based digital solutions focused on making digital inclusion a reality across communities in Bharat. We help entrepreneurs, small businesses, and organizations digitize their operations/processes with minimal technical knowledge required. Our solutions are designed to bridge the digital gap and empower people with simple, accessible, and scalable technology.",
    },
    {
      question: "How can GeeQR help my business?",
      answer:
        "GeeCom offers QR-based solutions that allow you to create a digital presence without the need for a Website or App. This system helps you promote your products / services, receive new leads / customers, manage orders, collect and analyze data, and reach more customers via a simple QR code. It's a fast, easy, and affordable way to bring your business online and reach a larger audience.",
    },
    {
      question: "Do I need technical skills to use GeeQR?",
      answer:
        "No, not at all! GeeQR solutions are specifically designed for users with minimal digital experience. Our QR-based solutions are user-friendly and work well on basic smart phones. We offer complete setup, training, support and easy-to-follow guides to help you get started and manage your business digitally, without needing any advanced technical skills.",
    },
  ];

  const faqData = {
    general: [
      {
        question: "What is GeeCom India?",
        answer:
          "GeeCom India is building a grassroots-first QR-based digital platform to make digital inclusion real for Bharat. Our solutions help farmers, FPOs, rural entrepreneurs, and organizations digitize their operations with minimal technical knowledge required.",
      },
      {
        question: "How can I contact GeeCom India?",
        answer:
          "You can contact us through our contact page or reach out via email at contact@geecoin.com.",
      },
    ],
    pricing: [
      {
        question: "What is the pricing model?",
        answer:
          "Our pricing is subscription-based. You can choose from various plans depending on the size and needs of your organization.",
      },
      {
        question: "Is there a free trial?",
        answer:
          "Yes, we offer a 14-day free trial to explore the features and understand how GeeCom can help your business.",
      },
    ],
    technical: [
      {
        question: "Do I need technical knowledge to use the platform?",
        answer:
          "No, our platform is designed to be user-friendly with minimal technical knowledge required. We provide training and support to get you started.",
      },
      {
        question: "What if I face technical issues?",
        answer:
          "Our technical support team is available 24/7 to assist you with any technical issues. You can reach us through our support page.",
      },
    ],
    features: [
      {
        question: "What features does GeeCom provide?",
        answer:
          "GeeCom offers a variety of features including QR-based digital solutions for rural entrepreneurs, easy management of operations, and detailed reporting tools.",
      },
      {
        question: "Can I integrate GeeCom with my existing systems?",
        answer:
          "Yes, we offer API integrations to seamlessly connect GeeCom with your existing systems.",
      },
    ],
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    AOS.init({
      duration: 600,
      once: true,
    });
  }, []);

  return (
    <>
      {/* Basic FAQ Section */}
      <section
        id="FAQ"
        className="bg-gradient-to-br from-[#E0F7FA] to-[#FFFFFF] py-16"
      >
        <div className="max-w-6xl mx-auto px-4" data-aos="fade-up">
          <div className="mb-12">
            <h3
              className="text-3xl font-bold text-gray-900 text-center"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Frequently Asked Questions
            </h3>
          </div>
          <div className="max-w-4xl mx-auto grid gap-8">
            {basicFaqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md p-6 md:p-8 transition-all"
                data-aos="fade-up"
                data-aos-delay={150 + index * 100}
              >
                <button
                  className="flex justify-between items-center w-full text-left focus:outline-none"
                  aria-expanded={openIndex === index}
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </span>
                  <svg
                    className={`h-5 w-5 text-gray-500 transform transition-transform duration-200 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {openIndex === index && (
                  <div className="mt-4" data-aos="fade-in" data-aos-delay="100">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <div
        className="mt-16 text-center"
        data-aos="fade-up"
        data-aos-duration="700"
      >
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Ready to Transform Your Business?
        </h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
          Join thousands of rural entrepreneurs who've already gone digital with
          GeeCom.
        </p>
        <div className="inline-flex flex-wrap justify-center gap-4">
          <a
            href="#contact"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-md font-medium text-lg transition-colors duration-300"
          >
            Get Started Now
          </a>
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-block bg-white border border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-md font-medium text-lg transition-colors duration-300"
          >
            Request Custom Quote
          </button>
        </div>
      </div>

      {/* Custom Quote Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          aria-modal="true"
          role="dialog"
        >
          {/* Modal container with scroll support on mobile */}
          <div className="relative w-full h-full flex items-center justify-center p-4 sm:p-6">
            {/* Modal Content */}
            <div
              className="relative bg-white rounded-lg w-full max-w-md max-h-full overflow-y-auto shadow-xl transform transition-all"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              {/* Close button */}
              <div className="absolute top-4 right-4">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none"
                  aria-label="Close modal"
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Request a Custom Quote
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-5">
                  Tell us about your specific needs and we'll create a tailored
                  solution for you.
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="space-y-4">
                    <div>
                      <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="organization"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Organization
                      </label>
                      <input
                        type="text"
                        id="organization"
                        name="organization"
                        value={formData.organization}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="requirements"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Requirements
                      </label>
                      <textarea
                        id="requirements"
                        name="requirements"
                        rows="4"
                        value={formData.requirements}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
                      ></textarea>
                    </div>

                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        id="terms"
                        name="terms"
                        checked={formData.terms}
                        onChange={handleInputChange}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded mt-1 focus:ring-blue-500"
                      />
                      <label
                        htmlFor="terms"
                        className="ml-2 text-sm text-gray-700"
                      >
                        I agree to the{" "}
                        <a href="#" className="text-blue-600 hover:underline">
                          Terms and Conditions
                        </a>
                      </label>
                    </div>
                  </div>

                  <div className="mt-6">
                    <button
                      type="submit"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md font-medium text-sm sm:text-base transition-colors duration-300"
                    >
                      Submit Request
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Detailed FAQ Section */}
      <section id="faq-detailed" className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              FAQ
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Find answers to frequently asked questions about GeeCom's digital
              solutions for rural entrepreneurs.
            </p>
          </div>

          <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
            <div className="hidden md:block md:col-span-2">
              <div className="sticky top-24">
                <img
                  src="https://images.unsplash.com/photo-1682695799561-033f55f75b25?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w2MzQ2fDB8MXxzZWFyY2h8Mnx8ZW1wb3BlcmluZyUyNTIwZmFybWVycyUyNTJDJTI1MjBmcG9zJTI1MkMlMjUyMHJ1cmFsJTI1MjBlbnRyZXByZW5ldXJzJTI1MjB0aHJvdWdoJTI1MjBmcnVnYWwlMjUyMHNpbXBsZSUyNTIwZGlnaXRhbCUyNTIwc29sdXRpb25zLiUyNTIwcmV0YWlsJTI1MjBtYXJrZXRpbmclMjUyMHNpbXBsaWZpZWQlMjUyMHRlY2hub2xvZ3kuJTI1MjBmYXElMjUyMHByb2Zlc3Npb25hbHxlbnwwfDB8fHwxNzQ1MjE1Mjk0fDA"
                  alt="Person looking out from a cave"
                  className="w-full h-auto rounded-lg object-cover"
                />

                <div className="mt-8 bg-blue-50 rounded-lg p-6">
                  <h4 className="font-medium text-gray-900 mb-3">
                    Still have questions?
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Our team is here to help you find the right digital solution
                    for your specific needs.
                  </p>
                  <a
                    href="#contact"
                    className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors text-sm"
                  >
                    Contact us
                    <svg
                      className="ml-2 w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div className="md:col-span-3">
              <div className="mb-8 flex flex-wrap gap-2" role="tablist">
                {["general", "pricing", "technical", "features"].map((tab) => (
                  <button
                    key={tab}
                    className={`px-4 py-2 rounded-md ${
                      activeTab === tab
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    } font-medium text-sm focus:outline-none`}
                    onClick={() => {
                      setActiveTab(tab);
                      setOpenIndex(null);
                    }}
                    aria-selected={activeTab === tab}
                    role="tab"
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>

              <div className="border-t border-gray-200 pt-6">
                {faqData[activeTab].map((faq, index) => (
                  <div key={index} className="faq-item">
                    <button
                      className="faq-question w-full flex items-start justify-between text-left focus:outline-none"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                      data-aos-duration="500"
                      aria-expanded={openIndex === index}
                      onClick={() => toggleAccordion(index)}
                    >
                      <span className="text-lg font-medium text-gray-900">
                        {faq.question}
                      </span>
                      <svg
                        className="faq-icon h-6 w-6 text-gray-500 transform transition-transform duration-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer mt-2">
                        <p className="text-gray-600">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
